/* ============================================================
   EVENTS.JS — Page-specific scripts for events.html
   ============================================================ */

/* GSAP reveal animations */
(function() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  if (document.body.classList.contains('reduce-motion')) return;

  gsap.utils.toArray('.event-card, .expect-card, .past-card').forEach((el, i) => {
    gsap.fromTo(el,
      { opacity: 0, y: 20 },
      {
        opacity: 1, y: 0,
        duration: 0.5,
        delay: i * 0.05,
        ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%' }
      }
    );
  });
})();
